
import TodayIssues from '@/components/Company/TodayIssues'

export default {
    components: {
        TodayIssues,
    },
}
